import React, { Fragment, useState, useEffect, useRef, memo } from 'react'
import { Dialog, Transition } from '@headlessui/react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import Logo from './../assist/triokzzlohgo.svg';
import { applyBOGO, groupPricedByProduct } from '../hooks/bogo';
import { TimerCount } from './productpage';

const usePreviousValue = value => {
  const myref = useRef();
  useEffect(() => {
    myref.current = value;
  }, [value]);
  return myref.current;
};

function ShoppingCard({ openshopping, setOpenShopping, onRemove, onCount, onOpen, setShowChild }) {
  let ListOfOrdered = useSelector(state => state.allProducts.order)
  const [open, setOpen] = useState(openshopping)
  const [addtocards, setaddtocards] = useState(ListOfOrdered)
  const [quantity, setQuantity] = useState(1)
  const [removeditem, setRemoveditem] = useState([])
  const [subtotal, setSubTotal] = useState(0)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const prevValue = usePreviousValue(ListOfOrdered)
  // inside your component, derive this from addtocards
  const { pricedUnits, totalOriginal, totalPayable, totalDiscount } = applyBOGO(addtocards || []);
  const groupedForDisplay = groupPricedByProduct(pricedUnits);
  // let session = JSON.parse(localStorage.getItem('PHONEOTPINFO'))
  // let siginUserInfo = JSON.parse(localStorage.getItem('signiniNFO'))
  // console.log(ListOfOrdered)
  const close = () => {
    setOpenShopping(!open)
    setOpen(!open)
  }
  useEffect(() => {

  }, [addtocards])
  useEffect(() => {
    setaddtocards(ListOfOrdered)
  }, [ListOfOrdered])

  // useEffect(() => {
  //     let subtotals = ListOfOrdered && ListOfOrdered.reduce((acc, curr) => {
  //         let itemtotal = curr.price * (curr.count ? curr.count : 1)
  //         return acc += itemtotal
  //     }, 0)
  //     setSubTotal(subtotals)
  // }, [quantity, removeditem, ListOfOrdered])

  // buy 1 get 1 offer total price unit
  // useEffect(() => {
  //     setaddtocards(groupedForDisplay)
  // }, [ListOfOrdered])

  useEffect(() => {
    let subtotals = ListOfOrdered && ListOfOrdered.reduce((acc, curr) => {
      let itemtotal = totalPayable
      return acc = itemtotal
    }, 0)
    setSubTotal(subtotals)
  }, [quantity, removeditem, ListOfOrdered, totalPayable])

  const checkoutlist = () => {
    let checkoutproducts = addtocards && addtocards.map((prod, i) => ({
      item_id: prod.id,
      item_name: prod.product_name,
      price: prod.real_prize,
      quantity: prod.count
    }));

    // if (window.gtag) {
    window.gtag('event', 'conversion', {
      send_to: 'AW-11415759693/QtgvCJ6asZEZEM3WusMq',
    });
    // }
    //Ga4 begin checkout tag
    window.gtag('event', 'begin_checkout', {
      currency: 'INR',
      value: subtotal,
      // items: addtocards && addtocards[0].,
      items: checkoutproducts
    })
    //   if(siginUserInfo){
    setTimeout(() => {
      navigate('/paymentgetway')
    }, 1000)
    //   }else{
    //       setShowChild(true)
    //   }


  }

  return (
    <Transition.Root show={true} as={Fragment}>
      <Dialog as="div" className="relative z-40" onClose={() => !close}>
        <Transition.Child
          as={Fragment}
          enter="ease-in-out duration-500"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in-out duration-500"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className={`fixed top-0 right-0 inset-0 bg-black/50 backdrop-blur-sm z-50 transition-opacity duration-300 ${open ? "opacity-100" : "opacity-0 pointer-events-none"}`} />
        </Transition.Child>

        <div className={`fixed top-0 right-0 h-full w-full max-w-md z-50 flex flex-col bg-white shadow-2xl transition-transform duration-300 ease-out ${open ? "translate-x-0" : "translate-x-full"}`}>


          {/* Header */}
          <div className="bg-violet-700 px-5 py-4 flex items-center justify-between flex-shrink-0">
            <img
              className="h-12 w-25"
              src={Logo}
              width="99" height="100%"
              alt="close"
            />
            <div>
              <Dialog.Title className="font-poppins font-black text-white text-lg">Your Cart 🛒</Dialog.Title>
              {subtotal > 0 && <p className="text-violet-200 text-xs">{addtocards.reduce((s, i) => s + i.count, 0)} items · Ready to checkout</p>}
            </div>
            <button onClick={() => close()} className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center text-white hover:bg-white/30 transition-colors">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <TimerCount />
          {subtotal < 1449 ? (
            <div className="bg-amber-50 border-b border-amber-100 px-5 py-3 flex-shrink-0">
              <div className="flex items-center justify-between mb-1.5">
                <span className="text-xs font-semibold text-amber-800">🚚 Add ₹{subtotal} more for FREE delivery!</span>
                <span className="text-xs text-amber-600">{Math.round(Math.min(100, (subtotal / 1499) * 100))}%</span>
              </div>
              <div className="w-full bg-amber-200 rounded-full h-1.5">
                <div className="bg-amber-500 h-1.5 rounded-full transition-all duration-500" style={{ width: `${Math.min(100, (subtotal / 1499) * 100)}%` }} />
              </div>
            </div>
          ) : (
            <div className="bg-green-50 border-b border-green-100 px-5 py-2.5 flex-shrink-0">
              <p className="text-green-700 text-xs font-semibold text-center">🎉 You've unlocked FREE Delivery!</p>
            </div>
          )}
          {/* Coupon banner */}
          {subtotal > 999 && <div className="bg-gradient-to-r from-violet-700 to-purple-800 px-5 py-2.5 flex-shrink-0">
            <p className="text-white text-xs font-semibold text-center">
              🎁 You just earned a bonus coupon! Use <span className="bg-white/20 px-1.5 py-0.5 rounded font-mono">TRIOK10</span> for extra 10% off on purchase
            </p>
          </div>}
          <Transition.Child
            as={Fragment}
            enter="transform transition ease-in-out duration-500 sm:duration-700"
            enterFrom="translate-x-full"
            enterTo="translate-x-0"
            leave="transform transition ease-in-out duration-500 sm:duration-700"
            leaveFrom="translate-x-0"
            leaveTo="translate-x-full"
          >
            <Dialog.Panel className="flex overflow-y-auto scrollbar-hide">
              <div className="flex h-full flex-col  bg-white shadow-xl">
                <div className="flex-1 overflow-y-auto px-1 py-6 sm:px-4">


                  <div className="mt-8">
                    <div className="flow-root">
                      {/* <ul role="list" className="-my-6 divide-y divide-gray-200">
                                                        {addtocards ? addtocards.map((product, i) => (
                                                            <li key={product.id} className="flex py-2 glass-card rounded-[5px] shadow-md overflow-hidden animate-float">
                                                                    
                                                                <div className="h-24 w-24 flex-shrink-0 overflow-hidden rounded-md border border-gray-200" onClick={() => {
                                                                    onOpen(product, i)
                                                                    // onRemove(product, i)
                                                                    // setRemoveditem(product)
                                                                    close()
                                                                }} >
                                                                    <img
                                                                        src={product.imageSrc}
                                                                        alt={product.imageAlt}
                                                                        className="h-full w-full object-cover object-center"
                                                                        width="100%" height="100%"
                                                                    />
                                                                </div>

                                                                <div className="ml-4 flex flex-1 flex-col">
                                                                    <div>
                                                                        <div className="flex justify-between text-xs font-medium text-gray-900">
                                                                            <h3 className='text-[10px]'>
                                                                                <a href={product.href}>{product.product_name}</a>
                                                                            </h3>
                                                                        </div>
                                                                        <div className="flex">
                                                                        <p className="text-xs font-bold">₹{(product.count * product.price).toLocaleString('en-US')}.00</p>
                                                                        <p className="ml-4 text-xs text-gray-300 line-through">₹{(product.real_prize).toLocaleString('en-US')}.00</p>
                                                                        <p className="ml-4 text-xs text-green-700 font-bold">₹{Math.floor(Math.abs(product.price - product.real_prize))}.00 off</p>

                                                                        </div>
                                                                        <p className="mt-1 text-[10px] text-gray-500">Color: {product.colors.name}</p>
                                                                    </div>
                                                                 
                                                                    <div className="flex items-end justify-between text-xs">
                                                                        <div className="flex custom-number-input">
                                                                        <p className='w-auto text-xs border p-1'>Size: {product && product.sizes && product.sizes.name}</p>
                                                                            <p  className="m-1 text-gray-700 text-xs">
                                                                                 Qty
                                                                            </p>
                                                                            <div className="flex flex-row h-5 w-auto rounded-lg relative bg-transparent">
                                                                                <button id="dropdown-phone-button" data-dropdown-toggle="dropdown-phone" className="flex-shrink-0 z-10 inline-flex items-center py-2.5 px-4 text-sm font-medium text-center text-gray-900 bg-gray-100 border border-gray-300 rounded-s-lg hover:bg-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 dark:focus:ring-gray-700 dark:text-white dark:border-gray-600" type="button">
                                                                                  
                                                                                    <select id="countries" value={product.count} onChange={(e) => {
                                                                                    onCount(e, product.id, i)
                                                                                    setQuantity(e) 
                                                                                }} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-auto  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                                                                                    <option defaultValue={product.count ? product.count : 1} value={product.count}>{product.count}</option>
                                                                                    <option value="1" >1</option>
                                                                                    <option value="2">2</option>
                                                                                    <option value="3">3</option>
                                                                                    <option value="4">4</option>
                                                                                    <option value="5">5</option>
                                                                                    <option value="6">6</option>
                                                                                    <option value="7">7</option>
                                                                                    <option value="8">8</option>
                                                                                    <option value="9">9</option>
                                                                                    <option value="10">10</option>
                                                                                </select>
                                                                                </button>
                                                                             
                                                                            </div>
                                                                             </div>
                                                                    </div>
                                                                    <div className="flex items-end justify-between text-xs">
                                                                    <h3 className='text-[10px]'></h3>
                                                                     <button
                                                                            type="button"
                                                                            className="font-medium text-indigo-600 hover:text-indigo-500"
                                                                            onClick={() => {
                                                                                onRemove(product, i)
                                                                                setRemoveditem(product)
                                                                            }}
                                                                        >
                                                                            Remove
                                                                        </button>
                                                                     </div>
                                                                </div>
                                                            </li>
                                                        )) : ""}
                                                    </ul> */}

                      {/* Scrollable cart body */}
                      <div >
                        {addtocards && addtocards.length === 0 ? (
                          <div className="flex flex-col items-center justify-center h-48 text-gray-400">
                            <span className="text-4xl mb-3">🛒</span>
                            <p className="text-sm font-medium">Your cart is empty</p>
                            <button onClick={() => { close() }} className="mt-4 text-violet-600 text-sm font-semibold underline">Start Shopping →</button>
                          </div>
                        ) : (
                          <div className="px-5 py-4 space-y-4">
                            {addtocards && addtocards.map((product, i) => {
                              const itemDiscount = Math.round((1 - product.price / product.real_prize) * 100)
                              const grouped = groupedForDisplay.find((g) => g.id === product.id);
                              const hasFree = grouped && grouped.freeCount > 0;
                              return (
                                <div key={product.id} className="flex gap-3 bg-gray-50 rounded-2xl p-3 border border-gray-100">
                                  <div className="w-20 h-20 rounded-xl overflow-hidden flex-shrink-0 bg-gray-100" onClick={() => {
                                    onOpen(product, i)
                                    close()
                                  }}>
                                    <img src={product.imageSrc} alt={product.name} className="w-full h-full object-cover" />
                                  </div>
                                  <div className="flex-1 min-w-0">
                                    <p className="text-sm font-semibold text-gray-800 leading-tight line-clamp-2 mb-1">{product.product_name}</p>
                                    <div className="flex items-center gap-2 mb-2">
                                      <span className="text-[10px] bg-gray-200 text-gray-600 px-1.5 py-0.5 rounded">{product && product.sizes && product.sizes.name}</span>
                                      <span className="text-[10px] bg-gray-200 text-gray-600 px-1.5 py-0.5 rounded">{product?.colors.name}</span>
                                      <span className="text-[10px] text-green-600 font-bold">{itemDiscount}% off</span>
                                      {product.offer && <span className="text-[10px] text-green-600 font-bold">{product.offer}</span>}
                                      {hasFree && (
                                        <span className="text-[10px] text-white bg-green-600 px-1.5 py-0.5 rounded">
                                          {grouped.freeCount} FREE
                                        </span>
                                      )}
                                    </div>
                                    <div className="flex items-center justify-between">
                                      <div>
                                      {product.offer && <span className='text-green-500 font-bold font-poppins p-1'> ₹{(grouped ? grouped.payableAmount : product.count * product.price).toLocaleString('en-US')}</span>}
                                        <span className={`font-poppins font-bold ${product.offer && "line-through"} text-gray-900`}>₹{(product.price * product.count).toLocaleString()}</span>
                                        <span className="text-gray-400 text-xs line-through ml-1.5">₹{(product.real_prize * product.count).toLocaleString()}</span>
                                      </div>
                                      <div className="flex items-center gap-1.5">
                                        <div className="flex flex-row h-5 w-auto rounded-lg relative bg-transparent">
                                          <button id="dropdown-phone-button" data-dropdown-toggle="dropdown-phone" className="flex-shrink-0 z-10 inline-flex items-center py-2.5 px-4 text-sm font-medium text-center text-gray-900 bg-gray-100 border border-gray-300 rounded-s-lg hover:bg-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 dark:focus:ring-gray-700 dark:text-white dark:border-gray-600" type="button">

                                            <select id="countries" value={product.count} onChange={(e) => {
                                              onCount(e, product.id, i)
                                              setQuantity(e)
                                            }} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-auto  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                                              <option defaultValue={product.count ? product.count : 1} value={product.count}>{product.count}</option>
                                              <option value="1" >1</option>
                                              <option value="2">2</option>
                                              <option value="3">3</option>
                                              <option value="4">4</option>
                                              <option value="5">5</option>
                                              <option value="6">6</option>
                                              <option value="7">7</option>
                                              <option value="8">8</option>
                                              <option value="9">9</option>
                                              <option value="10">10</option>
                                            </select>
                                          </button>

                                        </div>
                                      </div>
                                    </div>
                                    {/* <span className='text-[11px] mt-1 text-green-500 font-bold float-right'> ₹{(grouped ? grouped.payableAmount : product.count * product.price).toLocaleString('en-US')}</span> */}
                                    <button onClick={() => {
                                      onRemove(product, i)
                                      setRemoveditem(product)
                                      close()
                                    }} className="text-[11px] text-red-400 hover:text-red-600 mt-1 font-medium transition-colors">Remove</button>
                                  </div>
                                </div>
                              )
                            })}
                          </div>
                        )}
                      </div>

                    </div>
                  </div>
                </div>

                {/* <p className='text-end font-medium p-1'> Subtotal:- ₹ {subtotal && subtotal.toLocaleString('en-US')} /-</p> */}
                <div className="sm:px-2">

                  <div className="flex items-center justify-center">

                    <div className="flex-shrink-0 border-t border-gray-100 bg-white">


                      {/* <div className="absolute -top-10 -left-10 h-40 w-40 rounded-full bg-pink-500/20 blur-3xl animate-pulse"></div> */}
                      {/* <div className="absolute -bottom-10 -right-10 h-40 w-40 rounded-full bg-violet-500/20 blur-3xl animate-pulse"></div> */}
                      {/* Price breakdown */}
                      {subtotal > 0 && <div className="px-5 pb-3 space-y-1.5">
                        <div className="flex justify-between text-sm text-gray-600">
                          <span>Subtotal ({addtocards?.reduce((s, i) => s + i.count, 0)} items)</span>
                          <span>₹{totalPayable.toLocaleString('en-US')}</span>
                        </div>
                        <div className="flex justify-between text-sm text-green-600 font-medium">
                          <span>You're saving</span>
                          <span>−₹{totalDiscount.toLocaleString('en-US')} </span>
                        </div>

                        <div className="flex justify-between text-sm text-gray-600">
                          <span>Delivery</span>
                          <span className={subtotal === 0 ? "text-green-600 font-semibold" : ""}>{subtotal > 1449 ? "FREE" : `₹${ListOfOrdered && ListOfOrdered[0] && ListOfOrdered[0].delivery_charge}.00`}</span>
                        </div>
                        <div className="border-t border-dashed border-gray-200 pt-2 flex justify-between font-poppins font-black text-base text-gray-900">
                          <span>Total</span>
                          <span>₹{subtotal < 1449 ? (subtotal + (ListOfOrdered && ListOfOrdered[0] && ListOfOrdered[0].delivery_charge)) && (subtotal + (ListOfOrdered && ListOfOrdered[0] && ListOfOrdered[0].delivery_charge)).toLocaleString('en-US') : subtotal && subtotal.toLocaleString('en-US')}</span>
                        </div>
                        <p className="text-[11px] text-gray-400">✅ Prices are inclusive of all taxes</p>
                      </div>}

                      {/* Trust signals */}
                      <div className="px-5 pb-3 flex gap-4 text-[10px] text-gray-500">
                        <span className="flex items-center gap-1">🚚 Fast 2–5 days</span>
                        <span className="flex items-center gap-1">💳 UPI | COD | Cards</span>
                        <span className="flex items-center gap-1">↩️ 7-day returns</span>
                      </div>
                      {/* Checkout CTA */}
                      <div className="px-5 pb-5">
                        {subtotal > 0 && <button
                          onClick={() => checkoutlist()}
                          className="w-full relative overflow-hidden bg-gradient-to-r from-orange-500 to-pink-600 hover:from-orange-600 hover:to-pink-700 text-white font-poppins font-black text-lg py-4 rounded-2xl shadow-lg shadow-orange-200 transition-all active:scale-95"
                        >
                          <span className="relative z-10">Checkout Now →</span>
                        </button>}
                        <p className="text-center text-gray-400 text-xs mt-2.5">
                          🔒 100% Secure · or{" "}
                          <button onClick={() => close()} className="text-violet-600 font-semibold hover:underline">Continue Shopping</button>
                        </p>
                      </div>
                    </div>
                  </div>


                  {/* <p className="text-xs text-gray-500">✅ 100% Secure Checkout</p> */}
                  {/* <p className="text-xs text-gray-500"> 🛡️ Easy Returns</p> */}
                  {/* <p className="text-xs text-gray-500">💳 Pay with UPI | COD, Cards | Need help? Call us</p>  */}
                  {/* <p className="text-xs text-gray-500">⏰ Order within 2 hours to get it by 2-4 days</p> */}
                </div>
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>


      </Dialog>
    </Transition.Root>
  )
}
export default memo(ShoppingCard)